<template>
    <div>
        <v-window  v-model="showInfo" :touchless="true">
            <v-window-item  :value="true" >
                <soulinfo :partnerpreference="partnerpreference" @ShowEdit="showInfo = false"></soulinfo>
            </v-window-item>
            <v-window-item :value="false">
               <Infoform @userinfo="submitForm" :dropDownList="dropDownList" :partnerpreference="partnerpreference" :partnerpreferenceList="partnerpreferenceList" @closeInfo="showInfo = true"></Infoform>
            </v-window-item>
        </v-window>
         <v-window v-model="showRelegious" :touchless="true">
            <v-window-item :value="true" >
                <religious :partnerpreference="partnerpreference"  @ShowEdit="showRelegious = false"></religious>
            </v-window-item>
            <v-window-item :value="false">
               <Religiousform  @religious="submitForm" :dropDownList="dropDownList" :partnerpreference="partnerpreference" :partnerpreferenceList="partnerpreferenceList" @closeInfo="showRelegious = true"></Religiousform>
            </v-window-item>
        </v-window>
      <v-window  v-model="showLocations" :touchless="true">
            <v-window-item :value="true" >
                <Location :partnerpreference="partnerpreference" @ShowEdit="showLocations = false"></Location>
            </v-window-item>
            <v-window-item  :value="false">
               <LocationForm  @location="submitForm"  :dropDownList="dropDownList" :partnerpreference="partnerpreference" :partnerpreferenceList="partnerpreferenceList" @closeInfo="showLocations = true"></LocationForm>
            </v-window-item>
        </v-window>
         <v-window v-model="showCarrers" :touchless="true">
            <v-window-item :value="true" >
                <carrers  :partnerpreference="partnerpreference" @ShowEdit="showCarrers = false"></carrers>
            </v-window-item>
            <v-window-item :value="false">
               <carrerForm  @carrer="submitForm" :dropDownList="dropDownList" :partnerpreference="partnerpreference" :partnerpreferenceList="partnerpreferenceList" @closeInfo="showCarrers = true" ></carrerForm>
            </v-window-item> 
         </v-window>

    </div>
</template>
<script>
import soulinfo from './partnerDetails/soulinfo.vue';
import Infoform from './partnerDetailsForm/Infoform.vue';
import carrers from './partnerDetails/carrers.vue';
import carrerForm from './partnerDetailsForm/carrerForm.vue';
import religious from './partnerDetails/religious.vue';
import Religiousform from './partnerDetailsForm/Religiousform.vue';
import Location from './partnerDetails/Location.vue';
import LocationForm from './partnerDetailsForm/locationForm.vue';
import EventServices from '@/services/EventServices';
export default{
    components:{
        soulinfo,Infoform,carrers,carrerForm,religious,Religiousform,Location,LocationForm
    },
    data(){
        return{
showInfo:true,
showCarrers:true,
showLocations:true,
showRelegious:true,
clientId:localStorage.getItem("clientId") 

        }
    },
    props:{
        partnerpreference:{},partnerpreferenceList:[],dropDownList:{}
    },
    methods:{
        submitForm(Indicator) {
      this.$globalData.overlay = true
      EventServices.Setsoulpreference(this.partnerpreferenceList, Indicator,this.clientId)
        .then((response) => {
          if (response.data.status == "S") {
            this.MessageBar("S", response.data.errMsg)
            this.$emit('soulprefernce')
            this.showInfo = true
            this.showRelegious = true
            this.showCarrers = true
            this.showLocations = true
            this.$globalData.overlay = false

            this.loading = false
          } else {
            this.$globalData.overlay = false
            this.MessageBar("E", response.data.errMsg);
          }
        })
        .catch((error) => {
          this.$globalData.overlay = false
          this.MessageBar("E", error);
        });
    }}
}
</script>